import App from "@bloglovin/inspire-engine/App";
import { contextualAppName } from "%/dynamic-component-editor/classes/platform-standard-entities";

const STORY_ENTITY_TYPE = "Story";
const PUBLICATION_ENTITY_TYPE = "Publication";
const MEMBER_POSTS_FIELD = "memberPosts";

// Story is readOnly to the engine — its rows are externally backed by the
// content service, and the four write routines refuse it (assertEntityWritable).
// upsertEntity is the OTHER path: the one the engine itself uses to store rows
// that arrived from the server. The REST call has already persisted and handed
// back the authoritative counts, so this is that case exactly — and it updates
// the row in place instead of re-reading the whole feed.
export function applyStoryFields(storyId, fields) {
  if (!storyId || !fields) {
    return;
  }
  App.get(contextualAppName()).upsertEntity(
    STORY_ENTITY_TYPE,
    { id: Number(storyId) },
    fields,
    true,
    false,
    "member post action result",
  );
}

// memberPosts is an externallyBacked feed with no linking field, so the engine
// cannot work out on its own that a new story belongs in it — splice it in
// directly. getEntity creates the row placeholder and triggers the one-row
// lazy fetch that fills it, so the post appears immediately and completes a
// beat later without the feed re-reading every page it already holds.
export function insertMemberPostIntoFeed(publicationId, storyId) {
  if (!publicationId || !storyId) {
    return;
  }
  const app = App.get(contextualAppName());
  const store = app.getFeedStore(
    PUBLICATION_ENTITY_TYPE,
    { id: Number(publicationId) },
    MEMBER_POSTS_FIELD,
  );
  // Null when this page has no FeedV2 element — a Quick Post can live on a
  // page that never mounts the feed.
  if (!store) {
    return;
  }
  const pk = { id: Number(storyId) };
  const entity = app.getEntity(STORY_ENTITY_TYPE, pk);
  if (!entity) {
    return;
  }
  store.spliceItemIntoFeed(entity, pk);
}
